module.exports = __webpack_public_path__ + "img/graphs-mobile-4.d4b1ccae.svg";